import { Component, Input } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { UsersApiService } from '@core/api-services/users-api/users-api.service';
import { User } from '@core/models';
import { NavigationService } from '@core/services/navigation/navigation.service';

@Component({
  selector: 'el-buen-inquilino-auto-guarantor-modal',
  templateUrl: './auto-guarantor-modal.component.html',
  standalone: false
})
export class AutoGuarantorModalComponent {
  saving = false;
  @Input() user: User;

  constructor(
    private navigationService: NavigationService,
    private usersService: UsersApiService,
    private modalController: ModalController,
    private toastController: ToastController,
    private translate: TranslateService
  ) {}

  dismiss(): void {
    this.modalController.dismiss({
      dismissed: true
    });
  }

  saveAutoGuarantor(): void {
    this.saving = true;
    this.usersService.saveAutoGuarantor(this.user.id).subscribe(
      () => {
        this.presentToast(
          this.translate.instant(
            'components.auto_guarantor_modal.request_ok'
          ) as string,
          true
        );
        this.saving = false;
        this.navigationService.goToGuarantorHome(this.user.id);
        this.dismiss();
      },
      () => {
        this.saving = false;
        this.presentToast(
          this.translate.instant(
            'components.auto_guarantor_modal.request_fail'
          ) as string,
          false
        );
      }
    );
  }

  async presentToast(messages: string, error: boolean): Promise<void> {
    const toast = await this.toastController.create({
      message: messages,
      position: 'top',
      color: error ? 'success' : 'danger',
      duration: 2000
    });
    toast.present();
  }
}
